import { axios } from "../../Config/config";

export const upload_media = async ({ data }) => {
    return await axios.post("media/upload", data);
};
